import { Col, Modal, Row } from 'antd';
import classNames from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import AppFooter from './app-footer/AppFooter';
import AppFootnote from './app-footnote/AppFootnote';
import AppGameFormat from './app-gameFormat/AppGameFormat';
import AppHeader from './app-header/AppHeader';
import AppImage from './app-image/AppImage';
import AppParagraphs from './app-paragraphs/AppParagraphs';
import AppRefundDetails from './app-refundDetails/AppRefundDetails';
import AppTable from './app-table/AppTable';
import AppTitle from './app-title/AppTitle';
import AppVideoPop from './app-video-pop/AppVideoPop';
import styles from './AppContent.module.scss';
import AppTicketFilling from './app-ticket-filling/AppTicketFilling';
import AppSlider from './app-slider/AppSlider';
import AppPayoutTime from './app-payout-time/AppPayoutTime';
import { isStandAlonePage } from 'src/util';
import AppMatchInfo from './app-match-info/AppMatchInfo';
import AppImportantMatters from './app-important-matters/AppImportantMatters';

const components: any = {
    PageGenericHeader: AppHeader,
    PageGenericContentParagraphs: AppParagraphs,
    PageGenericTable: AppTable,
    PageGenericImage: AppImage,
    PageGenericFooter: AppFooter,
    PageGenericFootnote: AppFootnote,
    GameFormat: AppGameFormat,
    RefundDetails: AppRefundDetails,
    PageGenericVideo: AppVideoPop,
    MarksixTicketType: AppTicketFilling,
    PageGenericSlider: AppSlider,
    PayoutTime: AppPayoutTime,
    LeagueNTournament: AppMatchInfo,
    ImportantMatters: AppImportantMatters,
};

const AppContent = ({ pageData, title, routerPath, description }: any) => {
    const pageContent: any[] = pageData?.Content?.data;
    const withoutEnabeld = [
        'PageGenericHeader',
        'Expample',
        'GameFormat',
        'RefundDetails',
        'PayoutTime',
        'LeagueNTournament',
        'ImportantMatters',
    ];
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [videoLink, setVideoLink] = useState(null);
    const [videoPoster, setVideoPoster] = useState(null);
    const [modalTitle, setModalTitle] = useState(null);
    const [modalDescription, setModalDescription] = useState(null);
    const [videoAutoPlay, setVideoAutoPlay] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };

    const footNote = pageContent.find((c: any) => {
        const temName = c?.template?.name || c.__typename;
        return temName === 'PageGenericFootnote';
    });
    console.log(footNote);

    const handleCancel = () => {
        setIsModalOpen(false);
        setVideoLink(null);
        setVideoPoster(null);
    };

    const handleVideoPop = useCallback((event: any) => {
        const dataLink = event.currentTarget.attributes.getNamedItem('data-link').value;
        const dataPoster = event.currentTarget.attributes.getNamedItem('data-poster').value;
        const dataTitle = event.currentTarget.attributes.getNamedItem('data-title')?.value || '';
        const dataDesc =
            event.currentTarget.attributes.getNamedItem('data-description')?.value || '';
        const dataAutoPlay =
            event.currentTarget.attributes.getNamedItem('data-autoplay').value || false;

        setVideoLink(dataLink);
        setVideoPoster(dataPoster);
        setModalTitle(dataTitle);
        setModalDescription(dataDesc);
        setVideoAutoPlay(dataAutoPlay);
        showModal();
    }, []);

    const handleHoverImg = useCallback((event: any) => {
        const imgPath = event.currentTarget.attributes.getNamedItem('hoversrc').value;
        event.currentTarget.attributes.src.value = imgPath;
        event.currentTarget.removeEventListener('mouseover', handleHoverImg);
    }, []);

    useEffect(() => {
        const ref = document.querySelectorAll('.demo-video-pop');
        ref.forEach((item) => {
            item.addEventListener('click', handleVideoPop, false);
        });

        return () => {
            ref.forEach((item) => {
                item.removeEventListener('click', handleVideoPop);
            });
        };
    }, [handleVideoPop, pageContent]);

    useEffect(() => {
        const ref = document.querySelectorAll('.hoverImg');
        ref.forEach((item) => {
            item.addEventListener('mouseover', handleHoverImg, false);
        });
    }, [handleHoverImg, pageContent]);

    return (
        <>
            <div
                className={classNames(
                    styles.container,
                    isStandAlonePage(routerPath[0]) && styles['info-container'],
                    'bg-white mb-[10px]'
                )}
                style={{ boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.05)' }}
            >
                <Row>
                    <Col xs={isStandAlonePage(routerPath[0]) ? 24 : 0} md={24}>
                        <AppTitle Title={title} routerPath={routerPath}></AppTitle>
                    </Col>
                    {description && (
                        <Col
                            dangerouslySetInnerHTML={{
                                __html: description,
                            }}
                            className={styles.description}
                        ></Col>
                    )}
                </Row>
                <div className={classNames(styles['page-content'], 'flex flex-wrap py-3 md:py-6')}>
                    {pageContent.map((c: any, cIndex: number) => {
                        const temName = c?.template?.name || c.__typename;
                        const Tag = components[temName];
                        const enabled =
                            (withoutEnabeld.includes(temName) || c?.enabled?.value === '1') &&
                            temName !== 'PageGenericFootnote';
                        const itemPadding = classNames('md:px-6', 'px-3');
                        return enabled ? (
                            <div
                                key={temName + cIndex}
                                className={classNames(
                                    temName,
                                    styles['content-container'],
                                    'w-full',
                                    'overflow-hidden',
                                    itemPadding,
                                    c.styleclass?.value || '',
                                    c.key
                                )}
                            >
                                <Tag content={c} routerPath={routerPath} />
                            </div>
                        ) : (
                            ''
                        );
                    })}
                </div>

                <Modal
                    title={
                        <>
                            <div className={styles['modal-title']}>{modalTitle}</div>
                            <div className={styles['modal-desc']}>{modalDescription}</div>
                        </>
                    }
                    open={isModalOpen}
                    onCancel={handleCancel}
                    footer={null}
                    width={'60%'}
                    className={styles['modal-container']}
                    destroyOnClose={true}
                >
                    {videoLink && (
                        <AppVideoPop
                            videoPoster={videoPoster}
                            videoLink={videoLink}
                            isPopup={true}
                            videoAutoPlay={videoAutoPlay}
                        ></AppVideoPop>
                    )}
                </Modal>
            </div>
            {footNote && <AppFootnote content={footNote} />}
        </>
    );
};

export default AppContent;
